import { AssetListItem } from './AssetListItem';

const AllowedFavoriteContentTypes = {
  collection: 'collection',
  dataRole: 'dataRole',
  datasource: 'datasource',
  flow: 'flow',
  lens: 'lens',
  metric: 'metric',
  project: 'project',
  publishedConnection: 'publishedConnection',
  publishedConnectionTable: 'publishedConnectionTable',
  view: 'view',
  workbook: 'workbook',
};

export type FavoriteItemType = keyof typeof AllowedFavoriteContentTypes;

export function contentTypeCanBeFavorite(contentType: string): contentType is FavoriteItemType {
  return AllowedFavoriteContentTypes.hasOwnProperty(contentType);
}

export interface IFavorite extends AssetListItem {
  objectLuid?: string;
  objectType: FavoriteItemType;
  objectIdForFavoriting: string; // will match objectId except for datasources. See IDataSourceInfo
}

export const FavoriteKeys = {
  position: 'position'
};
